import script from "./EmailLaudoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailLaudoModal.vue?vue&type=script&setup=true&lang=js"

import "./EmailLaudoModal.vue?vue&type=style&index=0&id=246435f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246435f6"]])

export default __exports__